import correlations from 'services/http/api/correlations';
import integrations from 'services/http/api/integrations';
import brands from 'services/http/api/brands';
import ai from 'services/http/api/ai';
import type { HTTPFunctions } from '../types';

const api = (props: HTTPFunctions) => ({
  ...correlations(props),
  ...integrations(props),
  ...brands(props),
  ...ai(props)
});

export default api;
